<template>
  <section class="app-aproc">
    <v-container grid-list-xl>
      <v-layout
        row
        wrap
      >
        <v-flex
          lg12
          sm12
          xs12
        >
          <v-card
            outlined
            class="app-card"
          >
            <v-card-title class="app-card-title">
              Relatório de Julgamento a partir de 2024
            </v-card-title>
            <v-card-text class="app-card-content">
              <v-alert
                outlined
                type="info"
                text
              >
                Abaixo é possível pesquisar por relatório de julgamento. Basta
                digitar o Número Único do Processo (NUP).
              </v-alert>
              <br>
              <v-form
                ref="form"
                v-model="formModel.valid"
                lazy-validation
                @submit.prevent="onSubmit"
              >
                <v-row>
                  <v-col
                    :md="12"
                    :sm="12"
                    :xs="12"
                    cols="12"
                  >
                    <v-text-field
                      ref="infracao"
                      v-model="formModel.infracao"
                      v-mask="'#####.######/####-##'"
                      type="text"
                      label="Número Único do Processo (NUP)"
                      :placeholder="placeholder"
                      :rules="[rules.required, rules.min]"
                      filled
                      rounded
                      dense
                      append-icon="search"
                    />
                  </v-col>
                  <v-col
                    :md="9"
                    :sm="9"
                    :xs="12"
                    cols="12"
                  >
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="siteKey"
                      :load-recaptcha-script="true"
                      class="recaptcha"
                      @verify="verifyRecaptcha"
                      @expired="expiredRecaptcha"
                    />
                    <v-input
                      v-model="formModel.recaptcha"
                      :rules="[rules.required]"
                    />
                  </v-col>
                  <v-col
                    :md="3"
                    :sm="3"
                    :xs="12"
                    cols="12"
                  >
                    <v-btn
                      depressed
                      block
                      large
                      color="primary"
                      type="submit"
                    >
                      Continuar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
          <div
            v-if="isLoading"
            class="text-xs-center area-loading"
          >
            <v-progress-circular
              indeterminate
              color="primary"
              :size="20"
              :width="2"
            />
            <span class="text-loading">Buscando ...</span>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import VueRecaptcha from "vue-recaptcha";
import GlobalStore from "@/store/modules/global";
import MinioService from "@/services/minio.service";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import { mask } from "vue-the-mask";
import { delay } from "rxjs/operators";

export default Vue.extend({
  components: {
    VueRecaptcha,
  },
  metaInfo: {
    title: "Relatório de Julgamento - Central de Serviços",
  },
  data() {
    return {
      siteKey: VUE_APP_RECAPTCHA_KEY,
      isLoading: false,
      formModel: {
        infracao: null,
        recaptcha: null,
      },
      valid: false,
      rules: {
        required: (value) => !!value || "Esse campo deve ser preenchido",
        number: (value) => {
          let num = parseInt(value);
          return (
            (!!num && value == num) || "Campo númerico de 3 à 8 caracteres"
          );
        },
        max: (value) =>
          (!!value && value.length < 9) ||
          "Esse campo deve possuir até 8 caracteres",
        min: (value) =>
          (!!value && value.length >= 3) ||
          "Esse campo deve possuir pelo menos 3 caracteres",
      },
    };
  },
  computed: {
    placeholder() {
      return `Ex.: 00000.000000/${moment().year()}-${moment().format("DD")}`;
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    verifyRecaptcha(value) {
      this.formModel.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.formModel.recaptcha = null;
    },
    initData() {
      const { query } = this.$route;
      if (query && query.numero) {
        this.formModel.infracao = query.numero;
        this.onSubmit();
      }
    },
    onSubmit() {
      this.valid = this.$refs.form.validate();
      this.$router.replace({
        name: "",
        query: { numero: this.formModel.infracao },
      });
      if (this.valid) {
        this.isLoading = true;
        const { infracao, recaptcha } = this.formModel;
        MinioService.downloadNjiRelatorioJulgamento2024(infracao, recaptcha)
          .pipe(delay(1000))
          .subscribe(
            (document) => {
              this.download(document);
              this.isLoading = false;
            },
            (error) => {
              const message =
                "Alguns erros foram encontrados. Favor verifique o número do VIPROC";
              GlobalStore.setSnackBar({
                message,
                show: true,
                type: "error",
                timeout: 30000,
              });

              this.isLoading = false;
            }
          );
      }
    },
    download(document) {
      const blob = new Blob([document], {
        type: "application/pdf",
      });
      const url = window.URL.createObjectURL(blob);
      window.open(url);
    },
  },
});
</script>
